package dev.codetwister.ctdev

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ctdev.composeapp.generated.resources.Res
import ctdev.composeapp.generated.resources.ic_github
import ctdev.composeapp.generated.resources.ic_linkedin
import ctdev.composeapp.generated.resources.ic_medium
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

private data class SocialLink(
    val label: String,
    val url: String,
    val icon: DrawableResource,
    val gradientColors: List<Color>,
)

private val socialLinks = listOf(
    SocialLink("GitHub", "https://github.com/code-twister", Res.drawable.ic_github, listOf(Blue, Green)),
    SocialLink("LinkedIn", "https://www.linkedin.com/in/mihaly-nagy-7783ba34/", Res.drawable.ic_linkedin, listOf(Orange, Red)),
    SocialLink("Medium", "https://medium.com/@codetwister", Res.drawable.ic_medium, listOf(Color(0xFF22C55E), Green)),
)

@Composable
internal fun FooterLinks() {
    Row(
        horizontalArrangement = Arrangement.spacedBy(20.dp),
    ) {
        socialLinks.forEach { link ->
            SocialCard(link, Modifier.width(200.dp))
        }
    }
}

@Composable
private fun SocialCard(link: SocialLink, modifier: Modifier = Modifier) {
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(12.dp))
            .background(
                Brush.linearGradient(
                    colors = listOf(Color(0xE6141423), Color(0xF00F0F19)),
                ),
            )
            .border(1.dp, BgCardBorder, RoundedCornerShape(12.dp))
            .clickable {
                navigateToUrl(link.url)
            },
    ) {
        Row(
            modifier = Modifier.padding(horizontal = 28.dp, vertical = 22.dp),
            horizontalArrangement = Arrangement.spacedBy(14.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Image(
                painter = painterResource(link.icon),
                contentDescription = link.label,
                modifier = Modifier.size(32.dp),
            )
            Text(
                text = link.label,
                fontSize = 15.sp,
                fontWeight = FontWeight.SemiBold,
                color = TextPrimary,
            )
        }
        Box(
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .fillMaxWidth()
                .height(2.dp)
                .background(Brush.horizontalGradient(link.gradientColors)),
        )
    }
}

